import styled from 'styled-components';
import ModalBase from '../Modal/modal';

export const Modal = styled(ModalBase).attrs({
  bodyStyle: { padding: 0, overflow: 'hidden' },
})``;
